/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Role_InventoryInputs */

const en_role_inventory = /** @type {(inputs: Role_InventoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inventory`)
};

const es_role_inventory = /** @type {(inputs: Role_InventoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inventario`)
};

/**
* | output |
* | --- |
* | "Inventory" |
*
* @param {Role_InventoryInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const role_inventory = /** @type {((inputs?: Role_InventoryInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Role_InventoryInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_role_inventory(inputs)
	return es_role_inventory(inputs)
});